import { AlkLogger, ELogger } from '@alk/core';
import {
    IAppConfig,
    IAuthConfig,
    IKondorBlotterConfig,
    IRiskApiConfig,
    IWebSocketConfig,
} from '../interfaces';
import { parseLogLevel } from './app-config.utils';

export const APP_CONFIG = {
    VERSION: '<@VERSION@>',
    APP_NAME: '<@APP_NAME@>',
};

export const OFX_CONFIG: IAppConfig = {
    ENVIRONMENT: 'development',
    MOCK: false,
    OIDC: false,
    LOG_LEVEL: ELogger.INFO,
    ENABLE_LOG_IN_CONSOLE: false,
    SSO_ONLY: false,
    PORTAL_URL: '',
    HARD_REDIRECT_FOR_LOGIN_PAGE: false,
    ENABLE_BRANDING_COLOR: true,
    IS_STANDALONE: true,
};

export const OFX_WEB: IWebSocketConfig = {
    PROTOCOL: 'ws',
    GATEWAY_ADDRESS: 'localhost',
    PORT: '11000',
    WEB_SOCKET_URL: 'ofxapi/v1/websocket',
};

export const KONDOR_BLOTTER: IKondorBlotterConfig = {
    HAS_BLOTTER: false,
    PROTOCOL: 'http',
    ADDRESS: 'gdncslgdnqa0246.misys.global.ad',
    PORT: '8090',
};

export const RISK_API: IRiskApiConfig = {
    PROTOCOL: 'http',
    ADDRESS: 'gdncslgdnqa0246.misys.global.ad',
    PORT: '8090',
};

export const OFX_AUTH_CONFIG: IAuthConfig = {
    PROTOCOL: 'http',
    GATEWAY_ADDRESS: 'localhost',
    PORT: '11000',
};

let fetchingEnv: Promise<void>;

export function loadEnv(): Promise<void> {
    // @ts-expect-error type mismatch
    if (window.isStorybook) {
        OFX_CONFIG.MOCK = true;
        OFX_CONFIG.ENABLE_LOG_IN_CONSOLE = true;
        OFX_CONFIG.LOG_LEVEL = ELogger.DEBUG;

        return Promise.resolve();
    }

    if (!Boolean(fetchingEnv)) {
        fetchingEnv = fetch('../../manifests/environment.json')
            .then((res) => res.json())
            .then((env) => {
                OFX_WEB.PROTOCOL = env.PROTOCOL;
                OFX_WEB.GATEWAY_ADDRESS = env.GATEWAY_ADDRESS;
                OFX_WEB.PORT = env.PORT;
                OFX_WEB.WEB_SOCKET_URL = env.WEB_SOCKET_URL;

                KONDOR_BLOTTER.HAS_BLOTTER = env.K_BLOTTER === 'TRUE';
                KONDOR_BLOTTER.PROTOCOL = env.K_BLOTTER_PROTOCOL;
                KONDOR_BLOTTER.ADDRESS = env.K_BLOTTER_ADDRESS;
                KONDOR_BLOTTER.PORT = env.K_BLOTTER_PORT;

                RISK_API.PROTOCOL = env.RISK_API_PROTOCOL;
                RISK_API.ADDRESS = env.RISK_API_ADDRESS;
                RISK_API.PORT = env.RISK_API_PORT;

                OFX_AUTH_CONFIG.PROTOCOL = env.AUTH_PROTOCOL;
                OFX_AUTH_CONFIG.GATEWAY_ADDRESS = env.GATEWAY_ADDRESS;
                OFX_AUTH_CONFIG.PORT = env.PORT;

                OFX_CONFIG.ENVIRONMENT = env.ENV;
                OFX_CONFIG.MOCK = env.MOCK === 'TRUE';
                OFX_CONFIG.OIDC = env.OIDC === 'TRUE';
                OFX_CONFIG.LOG_LEVEL = parseLogLevel(ELogger.INFO)(env.LOG_LEVEL);
                OFX_CONFIG.ENABLE_LOG_IN_CONSOLE = env.ENABLE_LOG_IN_CONSOLE === 'TRUE';
                OFX_CONFIG.SSO_ONLY = env.SSO_ONLY === 'TRUE';
                OFX_CONFIG.PORTAL_URL = env.PORTAL_URL;
                OFX_CONFIG.HARD_REDIRECT_FOR_LOGIN_PAGE = env.HARD_REDIRECT_FOR_LOGIN_PAGE === 'TRUE';
                OFX_CONFIG.ENABLE_BRANDING_COLOR = env.ENABLE_BRANDING_COLOR ? env.ENABLE_BRANDING_COLOR === 'TRUE' : true;
                OFX_CONFIG.IS_STANDALONE = env.IS_STANDALONE ? env.IS_STANDALONE === 'TRUE' : true;
            }).then(() => {
                AlkLogger.info(`[APP_CONFIG] environment loaded ${ ''
                }${ JSON.stringify(OFX_CONFIG) } - ${ JSON.stringify(OFX_WEB) }`);
            });
    }

    return fetchingEnv;
}
